import AppDispatcher from '../dispatcher/AppDispatcher';
import constants from '../constants/EspHealthConstants';

class EspHealthActions {

  loadAllHealthIndexesRequest() {
    AppDispatcher.handleServerAction({
      type: constants.LOAD_ALL_HEALTH_INDEXES_REQUEST,
    });
  }

  loadAllHealthIndexes(payload) {
    AppDispatcher.handleServerAction({
      type: constants.LOAD_ALL_HEALTH_INDEXES,
      payload
    });
  }

  addHealthIndex(payload) {
    AppDispatcher.handleServerAction({
      type: constants.ADD_HEALTH_INDEX,
      payload
    });
  }

  updateHealthIndex(payload) {
    AppDispatcher.handleServerAction({
      type: constants.UPDATE_HEALTH_INDEX,
      payload
    });
  }

  getHealthIndexById(payload) {
    AppDispatcher.handleServerAction({
      type: constants.GET_HEALTH_INDEX_BY_ID,
      payload
    });
  }

  setHealthIndexDevices(payload) {
    AppDispatcher.handleServerAction({
      type: constants.SET_HEALTH_INDEX_DEVICES,
      payload
    });
  }

  setCreatedTagID(payload) {
    AppDispatcher.handleServerAction({
      type: constants.SET_CREATED_TAG_ID,
      payload
    });
  }

  setHealthIndexTags(id,payload) {
    AppDispatcher.handleServerAction({
      type: constants.SET_HEALTH_INDEX_TAGS,
      id,
      payload
    });
  }

//   loadUserRequest(userKey) {
//     AppDispatcher.handleServerAction({
//       type: constants.LOAD_USER_REQUEST,
//       userKey
//     });
//   }

//   loadUser(user) {
//     AppDispatcher.handleServerAction({
//       type: constants.LOAD_USER,
//       user
//     });
//   }

//   loadGroupsByUserRequest(userKey) {
//     AppDispatcher.handleServerAction({
//       type: constants.LOAD_GROUPS_BY_USER_REQUEST,
//       userKey
//     });
//   }

//   loadGroupsByUser(groups) {
//     AppDispatcher.handleServerAction({
//       type: constants.LOAD_GROUPS_BY_USER,
//       groups
//     });
//   }

  insertUser(healthIndex) {
    AppDispatcher.handleServerAction({
      type: constants.CREATE_HEALTH_INDEX,
      healthIndex
    });
  }

//   updateUser(user) {
//     AppDispatcher.handleServerAction({
//       type: constants.UPDATE_USER,
//       user
//     });
//   }

  deleteHealthIndex(id) {
    AppDispatcher.handleServerAction({
      type: constants.DELETE_HEALTH_INDEX,
      id
    });
  }

//   sendMail(id) {
//     AppDispatcher.handleServerAction({
//       type: constants.SEND_MAIL,
//       id
//     });
//   }

//   userUpdateGroup(group) {
//     AppDispatcher.handleServerAction({
//       type: constants.USER_UPDATE_GROUP,
//       group
//     });
//   }

//   deleteUserFromGroup(group) {
//     AppDispatcher.handleServerAction({
//       type: constants.DELETE_USER_FROM_GROUP_UV,
//       group
//     });
//   }
}

export default new EspHealthActions();